import React from 'react';
import ProtectedSwagger from '../components/ProtectedSwagger';
import { services } from '../config/services';

const service = services.find((item) => item.route === '/renapo');

const DicioBackRenapoAPIDoc = () => (
    <ProtectedSwagger
        service={service}
        url={process.env.PUBLIC_URL + '/json/openapi/dicio-back-renapo-openapi.json'}
    />
);

export default DicioBackRenapoAPIDoc;
